import {React,useEffect} from 'react';
import { Box, Button } from '@mui/material';
import { getString } from '../../functions/getString';

export default function FilterList({
    items,
    limit = 5,
    showAll = false,
    onToggleShowAll = () => {},     
    renderItem
}) {
    const visible = showAll ? items : items.slice(0, limit);
    const hasMore = items.length > limit;

    useEffect(()=>{
    if (typeof translateScript === "function") 
    {
        translateScript();
    }
    },[])
    return (
        <>
            {visible.map(renderItem)}
            
            {hasMore && (
                <Box textAlign="center" mt={1}>
                    <Button size="small" onClick={onToggleShowAll} sx={{textTransform:"none"}}>
                        {showAll ? getString('Show less') : getString('Show more')}
                    </Button>
                </Box>
            )}
        </>
    );
}
